<!--
//================================================================================
// ID:BC058C2
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC058C2
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2022/11/15 | 富士通Japan株式会社    | 新規作成
// 01.01.00 | 2023/02/13 | 富士通Japan株式会社    | 令和4年度改修対応（3次リリース）
// 01.02.00 | 2023/08/08 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
// 01.03.00 | 2024/04/22 | 富士通Japan株式会社    | 令和6年度改修対応
//================================================================================
-->
<template>
	<div class="contents__main contents__main--nyukyo">
		<error-message />
		<!-- 同居者注意文 -->
		<caution-message
			:tyuibunItems="disp.headerTyuiItems"
		/>
		<br/>
		<h2 class="contents__h2">{{ disp.chapter }}</h2>
		<section>
			<table class="contents__table--stripe detail">
				<tbody>
					<tr class="contents__input--tr">
						<th class="contents__input--title border__bottom-none">
							氏名<span class="contents__hissu">必須</span>
						</th>
						<td class="border__bottom-none">
							<div>
								<div id="contents--name__area">
									<div>
										氏：
										<text-input
											class="contents__input--text width-name-si"
											style="ime-mode: active"
											:modelValue="nyukyosyaForm.nmName1"
											:maxLength="15"
											:textType="TEXTINPUT_TYPE.FULL"
											:name="'氏名（氏）'"
											:placeholder="'例）東京'"
											:requireFlg="true"
											:groupId="'nmName'"
											@update:modelValue="nyukyosyaForm.nmName1 = $event"
											ref="nmName1"
											tabindex="1"
										/>
									</div>
									<div>
										名：
										<text-input
											class="contents__input--text width-name-si"
											style="ime-mode: active"
											:modelValue="nyukyosyaForm.nmName2"
											:name="'氏名（名）'"
											:maxLength="15"
											:textType="TEXTINPUT_TYPE.FULL"
											:placeholder="'例）太郎'"
											:requireFlg="true"
											:groupId="'nmName'"
											@update:modelValue="nyukyosyaForm.nmName2 = $event"
											ref="nmName2"
											tabindex="2"
										/>
									</div>
								</div>
							</div>
							<itemerror-message :groupId="'nmName'"/>
						</td>
					</tr>
					<tr class="background__color--white">
						<th class="contents__input--title">
							フリガナ<span class="contents__hissu">必須</span>
						</th>
						<td>
							<div>
								<div id="contents--name__area">
									<div>
										氏：
										<text-input
											class="contents__input--text width-name-si"
											style="ime-mode: active"
											:modelValue="nyukyosyaForm.nmKana1"
											:name="'フリガナ（氏）'"
											:maxLength="30"
											:textType="TEXTINPUT_TYPE.HALF_KANA"
											:placeholder="'例）ﾄｳｷｮｳ'"
											:requireFlg="true"
											:groupId="'nmKana'"
											@update:modelValue="nyukyosyaForm.nmKana1 = $event"
											ref="nmKana1"
											tabindex="3"
										/>
									</div>
									<div>
										名：
										<text-input
											class="contents__input--text width-name-si"
											style="ime-mode: active"
											:modelValue="nyukyosyaForm.nmKana2"
											:name="'フリガナ（名）'"
											:maxLength="30"
											:textType="TEXTINPUT_TYPE.HALF_KANA"
											:placeholder="'例）ﾀﾛｳ'"
											:requireFlg="true"
											:groupId="'nmKana'"
											@update:modelValue="nyukyosyaForm.nmKana2 = $event"
											ref="nmKana2"
											tabindex="4"
										/>
									</div>
								</div>
							</div>
							<itemerror-message :groupId="'nmKana'"/>
							<div>
								<p class="contents__caution">
									※カタカナで入力してください。
								</p>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--light-gray">
						<th class="contents__input--title">
							続柄<span class="contents__hissu">必須</span>
						</th>
						<td class="padding__bottom-10">
							<div>
								<list-box
									class="contents__input--select width-bosyu"
									:modelValue="nyukyosyaForm.cdTudukigara"
									:name="'続柄'"
									:cdType="'L0007'"
									:cdHanyo1="'1'"
									:requireFlg="true"
									:cdKbn="CD_HANDLE_TYPE.ID_CD"
									:groupId="'tudukigara'"
									@update:modelValue="nyukyosyaForm.cdTudukigara = $event"
									ref="tudukigara"
									tabindex="5">
								</list-box>
							</div>
							<itemerror-message :groupId="'tudukigara'"/>
							<div class="bosyu-message">
								<caution-message
									:tyuibunItems="disp.tudukigaraTyuiItems"
								/>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--white">
						<th class="contents__input--title">
							生年月日<span class="contents__hissu">必須</span>
						</th>
						<td >
							<div>
								<date-input
									:modelValue="nyukyosyaForm.dtBirthday"
									:name="'生年月日'"
									:requireFlg="true"
									:dateType="DATE_KIND.BIRTHDAY"
									:ageViewFlg="true"
									:groupId="'birthday'"
									@update:modelValue="nyukyosyaForm.dtBirthday = $event"
									ref="birthday"
									tabindex="6"
								/>
							</div>
							<itemerror-message :groupId="'birthday'"/>
							<caution-message
								:tyuibunItems="disp.birthdayTyuiItems"
							/>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--light-gray">
						<th class="contents__input--title">
							年間所得金額<span class="contents__hissu">必須</span>
						</th>
						<td class="padding__bottom-10">
							<div>
								<number-input
									class="contents__input--text width-syotoku"
									:modelValue="nyukyosyaForm.moSyotoku"
									:maxLength="8"
									:name="'年間所得金額'"
									:requireFlg="true"
									:numberType="NUMBERINPUT_TYPE.PERIOD"
									:groupId="'syotoku'"
									@update:modelValue="nyukyosyaForm.moSyotoku = $event"
									ref="syotoku"
									tabindex="10"
								/>&nbsp;円
							</div>
							<itemerror-message :groupId="'syotoku'"/>
							<caution-message
								:tyuibunItems="disp.syotoku1Items"
							/>
							<caution-message
								:tyuibunItems="disp.syotoku2Items"
							/>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--white">
						<th class="contents__input--title">特別控除</th>
						<td>
							<div class="cond__checkbox width-madori-item">
								<check-box
									:classDiv="'width-madori'"
									:modelValue="nyukyosyaForm.fgKojto"
									:cdType="'L0024'"
									:name="'特別控除'"
									:classItem="'width-kojyo-range'"
									:groupId="'kojto'"
									@update:modelValue="nyukyosyaForm.fgKojto = $event"
									ref="kojto"
									tabindex="11" />
							</div>
							<itemerror-message :groupId="'kojto'"/>
							<caution-message
								:tyuibunItems="disp.kojto1Items"
							/>
							<caution-message
								:tyuibunItems="disp.kojto2Items"
							/>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="div-toggle-select-margin">
				<h2 class="contents__h2">現在、申込者と同居していますか
					<label>
						<span class="contents__hissu2" style="margin-left: 10px;">必須</span>
					</label>
				</h2>
				<div class="contents__select-title">
					<div>
						<div>
							<toggle-button
								:classDiv="'width-dokyoUmu'"
								:modelValue="nyukyosyaForm.kbBekkyo"
								:name="'申込者との同居有無'"
								:requireFlg="true"
								:cdType="'L0068'"
								:groupId="'dokyoUmu'"
								:radioGroupName="'dokyoUmu'"
								:classItem="'toggle_btn-dokyoUmu'"
								@update:modelValue="nyukyosyaForm.kbBekkyo = $event"
								ref="dokyoUmu"
								tabindex="33" />
						</div>
						<div class="margin-dokyoUmuTyui">
							<itemerror-message :groupId="'dokyoUmu'"/>
						</div>
						<div class="div-dokyoUmuTyui">
							<caution-message
								:classDiv="'padding-left15'"
								:cdHanyo1="'T0012'"
								:cdHanyo2="formC2.bosyuHoshiki"
							/>
						</div>
					</div>
				</div>
				<div v-if="disp.isDokyoFlg" class="div-toggle-select-margin">
					<table class="contents__table--stripe detail">
						<tbody>
							<tr class="contents__input--tr">
								<th class="contents__input--title">住宅の種類
									<span class="contents__hissu">必須</span>
								</th>
								<td class="padding__bottom-10">
									<div>
										<list-box
											class="contents__input--select width-auto"
											:modelValue="nyukyosyaForm.cdBekkyoJyutaku"
											:name="'住宅の種類'"
											:requireFlg="true"
											:cdType="'L0019'"
											:cdKbn="CD_HANDLE_TYPE.ID_CD"
											@update:modelValue="changeDoJyutakuList"
											:groupId="'dokyoJyutakuKind'"
											ref="dokyoJyutakuKind"
											tabindex="34">
										</list-box>
									</div>
									<itemerror-message :groupId="'dokyoJyutakuKind'"/>
									<caution-message
										:tyuibunItems="disp.doJyutakuItems"
									/>
								</td>
							</tr>
							<tr>
								<th class="contents__input--title padding__bottom-zero">都営住宅に入居する理由</th>
								<td class="padding__top-zero">
									<div class="margin__top-9">
										<textarea-input
											class="contents__input--text width-nyukyoRiyu width-textarea"
											:modelValue="nyukyosyaForm.txNyukyoRiyu"
											:maxLength="200"
											:name="'都営住宅に入居する理由'"
											:requireFlg="false"
											:groupId="'txNyukyoRiyu'"
											@update:modelValue="nyukyosyaForm.txNyukyoRiyu = $event"
											ref="txNyukyoRiyu"
											tabindex="35" />
									</div>
									<itemerror-message :groupId="'txNyukyoRiyu'"/>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<table class="contents__table--stripe detail border__top-none">
				<tbody>
					<tr>
						<th class="border__bottom-none"></th>
						<td class="border__bottom-none"></td>
					</tr>
					<tr>
						<th colspan="2" class="contents__filter--title">
							<label>申込日時点の勤務先又は学校の名称・所在地（資格審査時に確認しますので、申込時点での入力は必須ではありません）</label>
							<div class="square-position2 float__right" @click="filterOpen()">
								<transition name="rotate" mode="out-in" key="rotate3">
									<font-awesome-icon :icon="['far', 'minus-square']" v-if="disp.isFilterOpen"/>
									<font-awesome-icon :icon="['far', 'plus-square']" v-else/>
								</transition>
							</div>
						</th>
					</tr>
					<tr v-if="disp.isFilterOpen" class="contents__input--tr background__color--white">
						<th class="contents__input--title">所在地</th>
						<td>
							<div class="width-trans-item">
								<text-input
									class="contents__input--text width-syozaichi"
									style="ime-mode: active"
									:modelValue="nyukyosyaForm.txSyozaichi"
									:maxLength="20"
									:textType="TEXTINPUT_TYPE.FULL"
									:name="'所在地'"
									:groupId="'syozaichi'"
									@update:modelValue="nyukyosyaForm.txSyozaichi = $event"
									ref="syozaichi"
									tabindex="36" />
							</div>
							<itemerror-message :groupId="'syozaichi'"/>
						</td>
					</tr>
					<tr v-if="disp.isFilterOpen" class="contents__input--tr background__color--light-gray">
						<th class="contents__input--title">名称</th>
						<td>
							<div>
								<text-input
									class="contents__input--text width-syozaichi"
									style="ime-mode: active"
									:modelValue="nyukyosyaForm.txName"
									:maxLength="20"
									:textType="TEXTINPUT_TYPE.FULL"
									:name="'名称'"
									:groupId="'name'"
									@update:modelValue="nyukyosyaForm.txName = $event"
									ref="name"
									tabindex="37" />
							</div>
							<itemerror-message :groupId="'name'"/>
						</td>
					</tr>
					<tr v-if="disp.isFilterOpen"  class="contents__input--tr background__color--white">
						<th class="contents__input--title">電話番号</th>
						<td>
							<div>
								<number-input
									class="contents__input--text width-phone"
									:modelValue="nyukyosyaForm.idTel1"
									:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
									:name="'電話番号（市外）'"
									:maxLength="5"
									:groupId="'tel'"
									@update:modelValue="nyukyosyaForm.idTel1 = $event"
									ref="idTel1"
									tabindex="38"
								/>
								-
								<number-input
									class="contents__input--text width-phone"
									:modelValue="nyukyosyaForm.idTel2"
									:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
									:name="'電話番号（市内）'"
									:maxLength="4"
									:groupId="'tel'"
									@update:modelValue="nyukyosyaForm.idTel2 = $event"
									ref="idTel2"
									tabindex="39"
								/>
								-
								<number-input
									class="contents__input--text width-phone"
									:modelValue="nyukyosyaForm.idTel3"
									:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
									:name="'電話番号（局番）'"
									:maxLength="4"
									:groupId="'tel'"
									@update:modelValue="nyukyosyaForm.idTel3 = $event"
									ref="idTel3"
									tabindex="40"
								/>
							</div>
							<itemerror-message :groupId="'tel'"/>
						</td>
					</tr>
					<tr v-if="disp.isFilterOpen" class="contents__input--tr background__color--light-gray">
						<th class="contents__input--title width-senyoarea-title">勤務（開業）開始日</th>
						<td>
							<div class="width-senyoarea-item">
								<date-input
									:modelValue="nyukyosyaForm.dtYmdStt"
									:name="'勤務（開業）開始日'"
									:dateType="DATE_KIND.KINMU_START"
									:groupId="'ymdstt'"
									@update:modelValue="nyukyosyaForm.dtYmdStt = $event"
									ref="ymdstt"
									tabindex="41"
								/>
							</div>
							<itemerror-message :groupId="'ymdstt'"/>
						</td>
					</tr>
					<tr v-if="disp.isFilterOpen" class="contents__input--tr background__color--white">
						<th class="contents__input--title">職業</th>
						<td>
							<div>
								<list-box
									class="contents__input--select width-auto"
									:modelValue="nyukyosyaForm.cdSyokugyo"
									:name="'職業'"
									:cdType="'L0023'"
									:cdKbn="CD_HANDLE_TYPE.ID_CD"
									:groupId="'syokugyo'"
									@update:modelValue="nyukyosyaForm.cdSyokugyo = $event"
									ref="syokugyo"
									tabindex="44">
								</list-box>
							</div>
							<itemerror-message :groupId="'syokugyo'"/>
						</td>
					</tr>
				</tbody>
			</table>
			<br/>
			<div id="contents__foot--button" class="contents__div--center margin__bottom-page">
				<div id="btn--prev-pc">
					<input type="button" :value="disp.prevButtonNm" class="contents__btn--cancel btn--prev" @click="prev" tabindex="45"/>
				</div>
				<div class="btn-toroku">
					<input type="button" value="同居者入力完了" class="contents__btn--confirm btn--complete btn--complete-width" tabindex="46" @click="complete"/>
				</div>
				<div :class="[!disp.isNextButton ? 'btn--next-width' : '']" >
					<span v-if="disp.isNextButton">
						<div id="btn--next-pc">
							<input type="button" value="次の同居者" class="contents__btn--confirm btn--next" tabindex="47" @click="next"/>
						</div>
					</span>
				</div>
			</div>
			<br/>
		</section>
	</div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import ItemErrorMessage from '@/components/ItemErrorMessage.vue';
import CautionMessage from '@/components/CautionMessage.vue';
import TextInput from '@/components/TextInput.vue';
import ListBox from '@/components/ListBox.vue';
import CheckBox from '@/components/CheckBox.vue';
import ToggleButton from '@/components/ToggleButton.vue';
import DateInput from '@/components/DateInput.vue';
import NumberInput from '@/components/NumberInput.vue';
import TextAreaInput from '@/components/TextAreaInput.vue';

import { co_post, co_put } from '@/common/ajaxUtility.js';
import { co_isEmpty } from '@/common/checkUtility';
import { co_editDate, co_calcAge, co_zenkaku2Hankaku } from '@/common/stringUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_confirmDialog } from '@/common/dialogUtility.js';
import { co_toTop } from '@/common/screenUtility.js';
import { API_LIST_ITEMS } from '@/const/route.js';

import { STORE_ERROR_CLEAR, STORE_VIEW_TITLE, STORE_VIEW_PROGRESS, STORE_ERROR_SET_INPUT_ERR,
			STORE_ERROR_IS_ERRFLG, STORE_ERROR_IS_INPUT_ERRFLG, STORE_ENV_GET_LASTACCESSTIME_UPDATEINTERVAL } from '@/const/store.js';
import { CD_HANDLE_TYPE, DATE_KIND, NUMBERINPUT_TYPE, TEXTINPUT_TYPE, DIALOG_BUTTON_LIST_KEY } from '@/const/const.js';
import { PATH_BC058_CHECK_KOJYO, PATH_BC058_UPDATETIME } from '@/const/route.js';

export default {
	name: "BC058C2",
	components: {
		'error-message': ErrorMessage,
		'itemerror-message': ItemErrorMessage,
		'caution-message' : CautionMessage,
		'text-input': TextInput,
		'list-box': ListBox,
		'check-box': CheckBox,
		'toggle-button': ToggleButton,
		'date-input': DateInput,
		'number-input': NumberInput,
		'textarea-input': TextAreaInput,
	},
	props: ['form'],
	data: function () {
		return {
			nyukyosyaForm: {
				noNyukyo: 0,					// 同居者番号
				nmName1: '',					// 氏名（氏）
				nmName2: '',					// 氏名（名）
				nmKana1: '',					// フリガナ（氏）
				nmKana2: '',					// フリガナ（名）
				cdTudukigara: '',				// 続柄
				nmTudukigara: '',				// 続柄（名称）
				dtBirthday: '',					// 生年月日
				kbGender: '', 					// 性別
				nmGender: '', 					// 性別（名称）
				moSyotoku: '',					// 年間所得
				fgKojto: '',					// 特別控除
				nmKojto: '',					// 特別控除（名称）
				kbBekkyo: '',					// 別居有無区分
				cdBekkyoJyutaku: '', 			// 別居住宅の種類
				nmBekkyoJyutaku: '', 			// 別居住宅の種類（名称）
				txNyukyoRiyu: '',				// 都営住宅に入居する理由
				txSyozaichi: '',				// 所在地
				txName: '',						// 名称
				idTel1: '',						// 電話番号（市外）
				idTel2: '',						// 電話番号（市内）
				idTel3: '',						// 電話番号（局番）
				dtYmdStt: '',					// 勤務（開業）開始日
				cdSyokugyo: '',					// 職業
				nmSyokugyo: '',					// 職業（名称）
				isInputCheck: false,			// 入力チェック結果
				viewFlg: false,					// 画面表示フラグ
			},
			disp: {
				chapter: '',					// 見出し
				headerTyuiItems: ['C0028'],		// 同居者外国人注意文リスト
				tudukigaraTyuiItems: ['C0029'],	// 同居者続柄注意文リスト
				birthdayTyuiItems: [],			// 同居者年齢注意文リスト
				syotoku1Items: ['C0034'],		// 年間所得注意文１リスト
				syotoku2Items: ['C0184'],		// 年間所得注意文２リスト
				kojto1Items: ['C0030'],			// 特別控除注意文１リスト
				kojto2Items: ['C0185'],			// 特別控除注意文２リスト
				doJyutakuItems: [],				// 同居住宅の種類注意文リスト
				isFilterOpen: false,			// 絞り込み開閉フラグ
				prevButtonNm: '',				// 戻るボタン名称
				isNextButton: true,				// 次の同居者ボタン表示フラグ
				tudukigaraList: [],				// 続柄リスト
				kojtoList: [],					// 特別控除リスト
				syokugyoList: [],				// 職業リスト
				isDokyoFlg: false,				// 同居者情報表示フラグ
				task: '',						// 最終アクセス時間更新タスク
			},
			errNoNyukyo:0,	// 入力チェックエラーとなった同居者番号
			formC2: [],		// 入力FORM
			CD_HANDLE_TYPE: CD_HANDLE_TYPE,
			DATE_KIND:DATE_KIND,
			NUMBERINPUT_TYPE: NUMBERINPUT_TYPE,
			TEXTINPUT_TYPE: TEXTINPUT_TYPE,
			co_editDate: co_editDate,
			co_calcAge: co_calcAge
		}
	},
	mounted: async function () {

		// フォーカス設定
		this.$refs.nmName1.focus();
	},
	created: async function() {

		// エラーをクリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 同機能内のパラメータ受け渡し
		this.formC2 = this.form;

		// 画面タイトル
		this.$store.commit(STORE_VIEW_TITLE, '同居者入力（随時募集・管理者用【代理申込み】）');

		// 画面項目設定
		let noNyukyo = this.$route.params.noNyukyo;
		this.drawNyukyosyaInfo(noNyukyo);

		// 続柄リスト
		this.disp.tudukigaraList = await this.createNameList('L0007');

		// 特別控除リスト
		this.disp.kojtoList = await this.createNameList('L0024');

		// 職業リスト
		this.disp.syokugyoList = await this.createNameList('L0023');

		// 同居者年齢注意文
		this.disp.birthdayTyuiItems = ['C0223'];

		// 別居予定者制御
		if (this.nyukyosyaForm.kbBekkyo == '2'){
			this.disp.isDokyoFlg = true;
		}

		// 最終アクセス時間更新処理
		let interval = this.$store.getters[STORE_ENV_GET_LASTACCESSTIME_UPDATEINTERVAL];
		this.disp.task = setInterval(async () => {	
			await co_put(PATH_BC058_UPDATETIME);
		}, interval);

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);
	},
	beforeUnmount: function() {
		// 最終アクセス時間更新破棄
		clearInterval(this.disp.task);
	},
	watch: {
		// 別居予定有無選択
		'nyukyosyaForm.kbBekkyo' : function () {

			if (this.nyukyosyaForm.kbBekkyo == '2'){
				this.disp.isDokyoFlg = true;
			} else {
				this.disp.isDokyoFlg = false;
				this.nyukyosyaForm.cdBekkyoJyutaku = "";
				this.disp.doJyutakuItems = new Array();
				this.nyukyosyaForm.txNyukyoRiyu = "";
			}
		}
	},
	methods: {
		// 同居者情報設定
		drawNyukyosyaInfo: async function (noNyukyo) {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 同居者勤務先等アコーデオン
			this.disp.isFilterOpen = false;

			// 画面項目設定
			let nyukyoInfo = this.formC2.nyukyoList[noNyukyo-1];
			this.nyukyosyaForm = nyukyoInfo;
			this.nyukyosyaForm.noNyukyo = noNyukyo;
			await this.$nextTick();
			this.$refs.birthday.setValue(this.nyukyosyaForm.dtBirthday);
			
			// 画面表示フラグを変更する
			this.formC2.nyukyoList[noNyukyo-1].viewFlg = true;

			if (noNyukyo > 1) {
				// 1人目以降の場合
				this.disp.chapter = '同居者情報（' + co_zenkaku2Hankaku(noNyukyo) + '人目・同居親族）　同居親族とは、申込者と一緒に都営住宅に入居する親族です。';
				this.disp.prevButtonNm = '前の同居者';
			} else {
				this.disp.chapter = '同居者情報（１人目・同居親族）　同居親族とは、申込者と一緒に都営住宅に入居する親族です。';
				this.disp.prevButtonNm = '戻る';
			}

			if (noNyukyo == Number(this.formC2.nuNyukyo-1) || noNyukyo > Number(this.formC2.nuNyukyo-1)) {
				// 最終同居者の場合、次の同居者ボタンを表示しない
				this.disp.isNextButton = false;
			} else {
				this.disp.isNextButton = true;
			}

			if (this.disp.isDokyoFlg) {
				this.changeDoJyutakuList(this.nyukyosyaForm.cdBekkyoJyutaku);
			}

			// フォーカス設定
			this.$refs.nmName1.focus();

			// ページトップへ遷移
			co_toTop();

		},
		// 同居者勤務先等アコーデオン開閉処理
		filterOpen: async function () {
			this.disp.isFilterOpen = !this.disp.isFilterOpen;
			if (this.disp.isFilterOpen) {
				await this.$nextTick();
				// 勤務（開業）開始日設定
				this.$refs.ymdstt.setValue(this.nyukyosyaForm.dtYmdStt, false);
			}
		},
		// 戻る、前の同居者ボタン
		prev: async function () {

			if (!await this.checkInput()) {
				// 入力チェックエラー有り
				this.nyukyosyaForm.isInputCheck = false;
			} else {
				// 入力チェック実施済み
				this.nyukyosyaForm.isInputCheck = true;
			}

			// 続柄名称変換
			this.nyukyosyaForm.nmTudukigara = this.cdToNameTudukigara(this.nyukyosyaForm.cdTudukigara);

			// 特別控除名称変換
			this.nyukyosyaForm.nmKojto = this.cdToNamekojto(this.nyukyosyaForm.fgKojto);		

			// 職業名称変換
			this.nyukyosyaForm.nmSyokugyo = this.cdToNameSyokugyo(this.nyukyosyaForm.cdSyokugyo);

			if (this.nyukyosyaForm.noNyukyo == 1) {

				if (this.formC2.nyukyoList.length == 1
					&& !this.nyukyosyaForm.isInputCheck) {
					// 同居者リスト再作成
					this.formC2.nyukyoList.shift();
					this.$emit('addNyukyosya', 1);
				}

				// 世帯の所得金額計算
				this.$emit('clacAmount');

				// 世帯情報入力画面に遷移
				this.$emit('back', 1);

			} else {

				// 同居者入力画面（前の同居者）に遷移
				this.drawNyukyosyaInfo(this.nyukyosyaForm.noNyukyo - 1);
			}
		},
		// 同居者入力完了ボタン
		complete: async function () {
			// チェック処理
			if (!await this.checkInput()) return;

			// 入力チェック実施済み
			this.nyukyosyaForm.isInputCheck = true;

			// 続柄名称変換
			this.nyukyosyaForm.nmTudukigara = this.cdToNameTudukigara(this.nyukyosyaForm.cdTudukigara);

			// 特別控除名称変換
			this.nyukyosyaForm.nmKojto = this.cdToNamekojto(this.nyukyosyaForm.fgKojto);

			// 職業名称変換
			this.nyukyosyaForm.nmSyokugyo = this.cdToNameSyokugyo(this.nyukyosyaForm.cdSyokugyo);

			// 世帯の所得金額計算
			this.$emit('clacAmount');

			// 全同居者チェック
			for (let i = 0; i < this.formC2.nyukyoList.length; i++) {
				let nyukyosyaInfo = this.formC2.nyukyoList[i];
				if (!nyukyosyaInfo.isInputCheck && nyukyosyaInfo.viewFlg) {
					this.errNoNyukyo = nyukyosyaInfo.noNyukyo;
					co_confirmDialog(co_getMessage('W0002', nyukyosyaInfo.noNyukyo, nyukyosyaInfo.noNyukyo), this.deleteNyukyosya);
					return;
				}
			}

			let listNo = this.formC2.nyukyoList.length;
			let nyukyosyaInfo = this.formC2.nyukyoList[listNo - 1];
			if (Number(this.formC2.nuNyukyo-1) > listNo && nyukyosyaInfo.isInputCheck) {
				// 同居者リスト追加
				this.$emit('addNyukyosya', listNo + 1);
			}

			// 世帯情報入力画面に遷移
			this.$emit('back', listNo);
		},
		// 次の同居者ボタン
		next: async function () {
			// チェック処理
			if (!await this.checkInput()) return;

			// 入力チェック済み
			this.nyukyosyaForm.isInputCheck = true;

			// 続柄名称変換
			this.nyukyosyaForm.nmTudukigara = this.cdToNameTudukigara(this.nyukyosyaForm.cdTudukigara);

			// 特別控除名称変換
			this.nyukyosyaForm.nmKojto = this.cdToNamekojto(this.nyukyosyaForm.fgKojto);

			let nextNo = Number(this.nyukyosyaForm.noNyukyo) + 1;
			if (nextNo > this.formC2.nyukyoList.length) {
				// 同居者リスト追加
				this.$emit('addNyukyosya', nextNo);
			}

			// 同居者入力画面（次の同居者）に遷移
			this.drawNyukyosyaInfo(nextNo);

		},
		// 同居者削除
		deleteNyukyosya: async function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// 同居者リスト指定行削除
				this.$emit('deleteNyukyosya', this.errNoNyukyo);

				// 世帯情報入力画面に遷移
				this.$emit('back', this.errNoNyukyo - 1);
			}
		},
		// 入力チェック
		checkInput: async function () {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 単項目チェック
			this.$refs.nmName1.validate();
			this.$refs.nmName2.validate();
			this.$refs.nmKana1.validate();
			this.$refs.nmKana2.validate();
			this.$refs.tudukigara.validate();
			this.$refs.birthday.validate();
			this.$refs.dokyoUmu.validate();

			if (this.disp.isDokyoFlg) {
				this.$refs.dokyoJyutakuKind.validate();
				this.$refs.txNyukyoRiyu.validate();
			}

			this.$refs.syotoku.validate();
			this.$refs.kojto.validate();

			// アコーディオンを開く
			this.disp.isFilterOpen = true;
			await this.$nextTick();
			this.$refs.ymdstt.setValue(this.nyukyosyaForm.dtYmdStt, false);

			this.$refs.syozaichi.validate();
			this.$refs.name.validate();
			this.$refs.idTel1.validate();
			this.$refs.idTel2.validate();
			this.$refs.idTel3.validate();
			this.$refs.ymdstt.validate();
			this.$refs.syokugyo.validate();

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				return false;
			}

			// 特別控除エラーチェック
			if (!co_isEmpty(this.nyukyosyaForm.fgKojto)) {
				let kojyoList = this.nyukyosyaForm.fgKojto.split(',');
				if (kojyoList.findIndex(item => item === '1') >= 0
					|| kojyoList.findIndex(item => item === '2') >= 0) {

					let params = {
						'dtBirthday' : this.nyukyosyaForm.dtBirthday,
						'fgKojRojin' : kojyoList.findIndex(item => item === '1') >= 0 ? '1' : '0',
						'fgKojTokutei' : kojyoList.findIndex(item => item === '2') >= 0 ? '1' : '0'
					};
					let result = await co_post(PATH_BC058_CHECK_KOJYO, params);
					if(result) {
						if (this.isFocus()) this.$refs.kojto.focus();
						this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'kojto', msg: co_getMessage('E0107')});
						this.$refs.kojto.setError();
					}
				}

				if (kojyoList.findIndex(item => item === '3') >= 0
					&& kojyoList.findIndex(item => item === '4') >= 0) {
					// 障害者、特別障害者が両方選択されている場合
					if (this.isFocus()) this.$refs.kojto.focus();
					this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'kojto', msg: co_getMessage('E0019')});
					this.$refs.kojto.setError();
				}

				if (kojyoList.findIndex(item => item === '5') >= 0
					&& kojyoList.findIndex(item => item === '6') >= 0) {
					// 寡婦、ひとり親が両方選択されている場合
					if (this.isFocus()) this.$refs.kojto.focus();
					this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'kojto', msg: co_getMessage('E0117')});
					this.$refs.kojto.setError();
				}
			}

			// 電話番号チェック
			if (!co_isEmpty(this.nyukyosyaForm.idTel1)
				|| !co_isEmpty(this.nyukyosyaForm.idTel2)
				|| !co_isEmpty(this.nyukyosyaForm.idTel3)) {
					if (co_isEmpty(this.nyukyosyaForm.idTel1)) {
						if (this.isFocus()) this.$refs.idTel1.focus();
						this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'tel', msg: co_getMessage('E0011', '電話番号（市外）')});
						this.$refs.idTel1.setError();
					}
					if (co_isEmpty(this.nyukyosyaForm.idTel2)) {
						if (this.isFocus()) this.$refs.idTel2.focus();
						this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'tel', msg: co_getMessage('E0011', '電話番号（市内）')});
						this.$refs.idTel2.setError();
					}
					if (co_isEmpty(this.nyukyosyaForm.idTel3)) {
						if (this.isFocus()) this.$refs.idTel3.focus();
						this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'tel', msg: co_getMessage('E0011', '電話番号（局番）')});
						this.$refs.idTel3.setError();
					}
			}

			// 年間所得金額チェック
			if (this.nyukyosyaForm.moSyotoku < 0) {
				// 年間所得金額エラー
				if (this.isFocus()) this.$refs.syotoku.focus();
				this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'syotoku', msg: co_getMessage('E0056', '年間所得金額', '0円以上')});
				this.$refs.syotoku.setError();
			}

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				return false;
			}

			return true;
		},
		// 名称リスト生成
		createNameList : async function (cd) {
			let resultList = [];
			let params = { cdType: cd, cdHanyo1: '', cdHanyo2: '', cdHanyo3: '' };
			let list = await co_post( API_LIST_ITEMS, params );
			if ( list != null ) {
				for ( let i = 0; i < list.length; i++ ) {
					// リストを追加
					resultList.push( {idCd: list[i].idCd, nmCd: list[i].nmCd} );
				}
			}

			return resultList;
		},
		// コード名称変換（続柄）
		cdToNameTudukigara : function (cd) {
			let index = this.disp.tudukigaraList.findIndex(item => item.idCd === cd);
			if (index < 0) return '';
			return this.disp.tudukigaraList[index].nmCd;
		},
		// コード名称変換（特別控除）
		cdToNamekojto : function (val) {
			let nmKojyo = '';

			if (!co_isEmpty(this.nyukyosyaForm.fgKojto)) {
				// 特別控除を選択している場合
				let kojyoList = val.split(',').sort();
				for (let i = 0; i < kojyoList.length; i++) {
					let index = this.disp.kojtoList.findIndex(item => item.idCd === kojyoList[i]);
					if (index >= 0) {
						nmKojyo = nmKojyo + this.disp.kojtoList[index].nmCd;
						if (i != kojyoList.length - 1) {
							nmKojyo = nmKojyo + '、';
						}
					} 
				}
			}

			return nmKojyo;
		},
		// コード名称変換（職業）
		cdToNameSyokugyo : function (cd) {
			let index = this.disp.syokugyoList.findIndex(item => item.idCd === cd);
			if (index < 0) return '';
			return this.disp.syokugyoList[index].nmCd;
		},
		// フォーカス設定必要有無を判定
		isFocus : function () {
			let inputError = this.$store.getters[STORE_ERROR_IS_INPUT_ERRFLG];
			if (!inputError) {
				return true;
			}
			return false;
		},
		// 同居住宅の種類リスト変更
		changeDoJyutakuList : function (val) {
			this.nyukyosyaForm.cdBekkyoJyutaku = val;

			let doJyutakuItems = new Array();
			if(this.nyukyosyaForm.cdBekkyoJyutaku == '6' || this.nyukyosyaForm.cdBekkyoJyutaku == '13') {
				doJyutakuItems.push('C0026');
			}
			this.disp.doJyutakuItems = doJyutakuItems;
		},
	}
};
</script>

<style scoped>

th {
	margin-bottom: -18px;
}

.width-textarea {
	width: -webkit-fill-available;
}

.width-dokyoUmu {
	margin-top:10px;
	margin-left:15px;
	padding-bottom: 20px;
}

.contents__hissu2 {
    background-color: #ee0000;
    color: #ffffff;
    font-size: 12px;
    margin: 5px 0;
    padding: 2px 2px;
    border-radius: 3px;
    line-height: 1.3em;
}

.div-toggle-select-margin {
    margin-top: 20px;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.contents__main--nyukyo {
		margin-top: 80px !important;
	}

	/* フッターボタン */
	#contents__foot--button {
		display: flex;
		flex-direction: row;
	}
	#contents__foot--button :nth-child(1) {
		order: 1;
		text-align: left;
	}
	#contents__foot--button :nth-child(2) {
		order: 2;
		margin: auto;
		text-align: center;
	}
	#contents__foot--button :nth-child(3) {
		order: 3;
		text-align: right;
	}

	.btn--next-width {
		width: 8%;
	}

	.width-name-si {
		width: 76% !important;
	}
	.contents__filter--title {
		background-color: #cdcdcd;
		padding-top: 0px;
		padding-bottom: 0px;
	}

	.contents__select-title {
		padding-bottom: 10px;
	}

	.margin-dokyoUmuTyui {
		padding-top: 45px;
	}

	.div-dokyoUmuTyui {
		margin-bottom: -15px;
	}

	.padding-left15 {
		padding-left: 15px;
	}

	.width-nyukyoRiyu {
		height: 96px;
	}
}
</style>